import { bool, func, string } from 'prop-types'
import { Component } from 'react'
import { TextInput } from '@opallabs/kuiper'

class PhaseNameField extends Component {
  static propTypes = {
    disabled: bool,
    name: string,
    onChangeName: func,
    phaseType: string,
  }

  constructor(props) {
    super(props)
    this.state = {
      name: this.props.name,
    }
  }

  get placeholder() {
    if (this.props.phaseType === 'task') {
      return 'Task Phase'
    }
    return 'Approval Phase'
  }

  onInputBlur = (value) => {
    if (value !== this.props.name) {
      this.props.onChangeName({ name: value })
    }
  }

  onInputChange = (value) => {
    this.setState({ name: value })
  }

  render() {
    return (
      <TextInput
        disabled={this.props.disabled}
        highlightOnFocus={true}
        maxLength={40}
        onBlur={this.onInputBlur}
        onChange={this.onInputChange}
        placeholder={this.placeholder}
        resetOnBlur={true}
        strict={true}
        tabIndex={0}
        theme="invisible light"
        truncate={true}
        value={this.state.name}
        valid={true}
      />
    )
  }
}

export default PhaseNameField
